module.exports = __webpack_public_path__ + "img/pic2.ab948a0c.png";